import clsx from 'clsx';
import React from 'react';
import { DsmRadius } from '../../constants/radii.mjs';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import classes from './ImageAction.module.css.mjs';

const ImageAction = polymorphicFactory(
  (props, ref) => {
    const { component = "button", className, icon: Icon, type, label, ...rest } = props;
    return /* @__PURE__ */ React.createElement(
      Flex,
      {
        ref,
        component,
        type: component === "button" ? type || "button" : void 0,
        justify: "center",
        align: "center",
        gap: 10,
        cursor: "pointer",
        borderRadius: DsmRadius.S,
        padding: label ? "6px 30px" : "3px",
        className: clsx(
          "kohler-image-action-root",
          classes.imageActionRoot,
          label ? classes.imageActionLabel : classes.imageActionWithoutLabel,
          className
        ),
        ...rest
      },
      Icon && /* @__PURE__ */ React.createElement(Icon, { size: label ? "small" : "medium", withBoundingBox: !label, style: { flexShrink: 0 } }),
      label && /* @__PURE__ */ React.createElement(Typography, { size: "button-m" }, label)
    );
  }
);

export { ImageAction };
